import React from 'react'
import styles from './Actions.module.scss'
import { Dropdown, Menu, Popconfirm } from 'antd';
import classNames from 'classnames';
import { FaMinus, FaPlay, FaPlus, FaQuestion } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import i18n from '../../../../../lib/i18n';
import { useDispatch } from 'react-redux';
import { deleteSliderItems } from '../../../actions';
import UploadSliderImg from './components/UploadSliderImg/UploadSliderImg';
import UploadSliderPdf from './components/UploadSliderPdf/UploadSliderPdf';
import UploadSliderPptx from './components/UploadSliderPptx/UploadSliderPptx';
import UploadSliderVideo from './components/UploadSliderVideo/UploadSliderVideo';

function Actions({ selectedSliders, countImgs, }) {

  const dispatch = useDispatch()


  const itemsMenu = [
    {
      key: '1',
      label: <UploadSliderImg countImgs={countImgs} />,
    },
    {
      key: '2',
      label: <UploadSliderPdf countImgs={countImgs} />,
    },
    {
      key: '3',
      label: <UploadSliderPptx countImgs={countImgs} />,
    },
    {
      key: '4',
      label: <UploadSliderVideo countImgs={countImgs} />,
    },
  ];

  return (
    <div className={styles.Actions}>
      <Dropdown menu={{
        items: itemsMenu,
      }} placement="bottomLeft">
        <div className={classNames(styles["new-slide"])}>
          <FaPlus />
        </div>
      </Dropdown>
      <Popconfirm
        title={i18n('pr_delete_item_title')}
        description={i18n('pr_delete_item_msg')}
        onConfirm={() => {
          dispatch(deleteSliderItems(selectedSliders))
        }}
        disabled={!selectedSliders.length}
        okText={i18n("Yes")}
        cancelText={i18n("No")}
      >
        <div className={classNames(styles["delete-slide"], { [styles.disabled]: !selectedSliders.length })} onClick={() => {
          if (!selectedSliders.length) {
            return
          }

        }}><FaMinus /></div>
      </Popconfirm>
    </div>
  )
}

export default Actions